import React from 'react';
import About from './About';
import Banner from './Banner';
import Footer from './Footer';
import Projects from './Projects';
import Skill from './Skill';


const Home = () => {
    return (
        <div className='bg-black text-white'>
            <Banner></Banner>
            <About path='about'></About>

            <Projects></Projects>
            <Skill></Skill>
            <Footer></Footer>
        </div>
    );
};

export default Home;